/** Maps resource names to their permission resource type */
export const resourcePermissionMap: Record<string, string> = {
  user: 'user',
  group: 'group',
  role: 'role',
  permission: 'permission',
  company: 'company',
  'job-application': 'job-application',
  'job-application-source': 'job-application-source',
  'job-application-status': 'job-application-status',
  'job-application-closure-reason': 'job-application-closure-reason',
  'job-application-calendar': 'job-application',
  'job-application-dashboard': 'job-application',
  'courses-management': 'course',
  'my-courses': 'course',
  file: 'file',
  'business-intelligence/market-analysis': 'report',
  'business-intelligence/sales': 'report',
  'business-intelligence/geographic-analysis': 'report',
  'business-intelligence/pipeline-analysis': 'report',
  'business-intelligence/irt': 'report',
  // Chat/Ticket resources
  tickets: 'conversation',
  conversations: 'conversation',
  conversation: 'conversation',
  ticket: 'ticket',
  contact: 'contact',
  channel: 'channel',
  'ticket-queue': 'ticket-queue',
  'ticket-quick-reply': 'ticket-quick-reply',
  tag: 'tag',
  'ticket-tag': 'tag',
  'conversation-tag': 'tag',
  'job-application-tag': 'tag',
};

/** Maps React Admin actions to permission action suffixes */
export const actionPermissionMap: Record<string, string> = {
  list: 'read',
  show: 'read',
  create: 'create',
  edit: 'update',
  delete: 'delete',
  export: 'export',
};

/** Resources with non-standard permission actions (checked instead of `{resource}:{action}`) */
export const specialPermissions: Record<string, string> = {
  'my-courses': 'course:view-my',
  'business-intelligence/market-analysis': 'course:view-my',
};

/**
 * Ordered list of navigable routes for redirect-after-login.
 * First accessible match wins. Each entry: [route, requiredPermission].
 */
export const defaultRoutes: [string, string][] = [
  ['/user', 'user:read'],
  ['/job-application-dashboard', 'job-application:read'],
  ['/job-application', 'job-application:read'],
  ['/company', 'company:read'],
  ['/courses-management', 'course:read'],
  ['/my-courses', 'course:view-my'],
];
